import { BaseInputField } from 'components/Input/InputField/BaseInputField';
import { BaseInputFieldProps } from 'components/Input/InputField/BaseInputField/types';

export type TextFieldProps = BaseInputFieldProps;

export const TextField = (props: TextFieldProps) => {
  return <BaseInputField {...props} />;
};

export default TextField;
